$(function(){
  $('.menu-icon').on('click', function(e){
    e.preventDefault();
    e.stopPropagation();
    $(".mobile-menu").addClass("active");
  });

  $('body').on('click', function(e) {
    $(".mobile-menu").removeClass('active');
  });
});